if (document.documentElement.classList.contains('scroll-reveal-enabled')) {
  const sections = document.querySelectorAll('#MainContent > .shopify-section');

  const observer = new IntersectionObserver(
    (entries, obs) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('scroll-reveal--visible');
          obs.unobserve(entry.target);
        }
      }
    },
    { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
  );

  for (const section of sections) {
    observer.observe(section);
  }
}
